<ng-container *transloco="let _t">

<h3 mat-dialog-title>{{title}}</h3>
<div mat-dialog-content>
<form MatDialogContent class="example-form">
    <input matInput type="text"
     [placeholder]="_t('app-autocomplete-dialog-placeholder-0')"
    [formControl]="myControl" [matAutocomplete]="auto"
   >
  

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
      <mat-option *ngFor="let option of filteredOptions | async; let i=index" [value]="option" >
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  
</form>
</div>
<div mat-dialog-actions>
  <button matInput color="warn" id="cancel" (click)="dialogRef.close()">{{ _t('Annuler') }}</button>
</div>

</ng-container>